import { registerFunctionalComponent } from 'js/lib/components/component'

registerFunctionalComponent('.js-c-pages-payments-resolve', 'PagesPaymentsResolve', component => {
  const interval = Number(component.element.dataset.pollInterval) || 1000
  let timeoutId = null
  let stopped = false

  const schedulePoll = () => {
    timeoutId = window.setTimeout(poll, interval)
  }

  const poll = () => {
    window.fetch(window.location.href, { credentials: 'same-origin' }).then(response => {
      if (stopped) {
        return
      }

      if (response.redirected) {
        window.location.href = response.url
        return
      }

      schedulePoll()
    }).catch(() => {
      if (!stopped) {
        schedulePoll()
      }
    })
  }

  component.useHandler(() => () => {
    stopped = true
    window.clearTimeout(timeoutId)
  })

  schedulePoll()
})
